import { render, staticRenderFns } from "./OrdenCompraIngreso.vue?vue&type=template&id=22af9fdd&"
import script from "./OrdenCompraIngreso.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraIngreso.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraIngreso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports